import React, {useState, useEffect} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";
import {
  apollo_useStyles,
  getModalStyle,
  Option,
} from "../../atom/Apollo_styles";
import {Industory, Industorycategory, Product} from "./Apollo_MasterModel";
import {
  apollo_industorycategory_master_path,
  apollo_industory_master_path,
  apollo_product_master_path,
  masterindustorys_path,
  masterproducts_path,
} from "../../atom/Apollo_links";
import {ApolloMessage} from "../../atom/Apollo_Mesasge"
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// メッセージ定義
import {
  GetMessage,
  UI_MASTER_INDUSTORY_MODAL,
} from "../../atom/Apollo_MesasgeDefinition";
// ドロワー(認証期間切れの場合にドロワーを閉じるため)
import {ApolloRightDrawerContext} from "../../molecule/Apollo_RightDrawer";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// MODAL
import Card from "@material-ui/core/Card/Card";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import classNames from "classnames";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

// モーダル引数
export type PropsModal = {
  setRead: any
  read: any
  industorycategoryId: any
  industoryId: any
  setIndustoryId: any
  productId: any
  setProductId: any
  setIndustoryName: any
  setIndustoryNameOld: any
  setProductName: any
  setIndustoryNameLog: any
};

interface MasterIndustoryModalProps {
  propsModal:PropsModal
};

  // 業種カテゴリ・業種マスタ・商品マスタモーダル表示
export default function ApolloMasterIndustoryModal(props: MasterIndustoryModalProps) {
  // プロパティ
  const {
    industorycategoryId,
    industoryId,
    setIndustoryId,
    productId,
    setProductId,
    setIndustoryName,
    setIndustoryNameOld,
    setProductName,
    setIndustoryNameLog,
  } = props.propsModal;

  // オプション+カテゴリ定義
  type OptionLocal = {
    value: number;
    label: string;
    category: number;
  }

  const classes = apollo_useStyles();
  const buttonClass = classNames(classes.button);
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [industorycategory, setIndustorycategory] = React.useState<Industorycategory[]>([]);
  const [industory, setIndustory] = React.useState<Industory[]>([]);
  const [product, setProduct] = React.useState<Product[]>([]);

  const [optionCategories, setOptionCategories] = React.useState<Option[]>([]);
  const [optionIndustries, setOptionIndustries] = React.useState<OptionLocal[]>([]);
  const [optionProducts, setOptionProducts] = React.useState<OptionLocal[]>([]);
  const [tempIndustries, setTempIndustries] = React.useState<OptionLocal[]>([]);
  const [tempProducts, setTempProducts] = React.useState<OptionLocal[]>([]);

  const [categoryIdLocal, setCategoryIdLocal] = React.useState<number>(industorycategoryId);
  const [industoryIdLocal, setIndustoryIdLocal] = React.useState<number>(industoryId);
  const [productIdLocal, setProductIdLocal] = React.useState<number>(productId);

  const [commitDisabled, setCommitDisabled] = React.useState(true);
  const [redisplay, setRedisplay] = React.useState(0);

  // ドロワー(認証期間切れの場合にドロワーを閉じるため)
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  // モーダルスタイル
  const bStyle = {
    top: "40%",
  }

  // 業種カテゴリ・業種マスタ・商品マスタ取得
  useEffect(() => {
    // 初期表示は読み込まない
    if (redisplay === 0) return;
    setIndustorycategory([]);
    setIndustory([]);
    setProduct([]);
    // 業種カテゴリ取得
    const urlIndustorycategory = apollo_industorycategory_master_path;
    ApolloAxios.get(urlIndustorycategory).then(response => {
      if (response.data.resultCode === 0) {
        setIndustorycategory(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_MASTER_INDUSTORY_MODAL,"E","0"),
          },
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_MASTER_INDUSTORY_MODAL,"E","0"), data, setmsg, history, setDrawerState, drawerState)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    // 業種マスタ取得
    const urlIndustory = apollo_industory_master_path;
    ApolloAxios.get(urlIndustory).then(response => {
      if (response.data.resultCode === 0) {
        setIndustory(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_MASTER_INDUSTORY_MODAL,"E","1"),
          },
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_MASTER_INDUSTORY_MODAL,"E","1"), data, setmsg, history, setDrawerState, drawerState)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    // 商品マスタ取得
    const urlProduct = apollo_product_master_path;
    ApolloAxios.get(urlProduct).then(response => {
      if (response.data.resultCode === 0) {
        setProduct(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_MASTER_INDUSTORY_MODAL,"E","2"),
          },
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_MASTER_INDUSTORY_MODAL,"E","2"), data, setmsg, history, setDrawerState, drawerState)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [redisplay]);

  useEffect(() => {
    if (industorycategory.length === 0 || industory.length === 0 || product.length === 0) return;
    // 各種リスト初期設定
    initList();
  }, [industorycategory, industory, product]);

  // 各種リスト初期設定
  const initList = () => {
    // 業種カテゴリリストを作成する
    createCategoryOption(industorycategory);
    // 業種リストを作成する
    let optionsIndustory = createIndustoryOption(industory);
    // 商品リストを作成する
    let optionsProduct = createProductOption(product);

    let productIdDefault = productId;
    // 商品IDから業種IDを取得する
    let industoryIdDefault = 0;
    product?.map((data, index) => {
      if (data.productId === productId) {
        industoryIdDefault = data.industoryId;
      }
    });
    // 業種IDから業種カテゴリIDを取得する
    let industoryCategoryIdDefault = 0;
    industory?.map((data, _) => {
      if (data.industoryId === industoryIdDefault) {
        industoryCategoryIdDefault = data.industorycategoryId;
      }
    });
    // 業種カテゴリIDをセットする
    setCategoryIdLocal(industoryCategoryIdDefault);
    // 業種IDをセットする
    setIndustoryIdLocal(industoryIdDefault);
    // 商品IDをセットする
    setProductIdLocal(productIdDefault);
    // 業種リストを作成する
    createNewOption(industoryCategoryIdDefault, optionsIndustory);
    // 商品リストを作成する
    createNewOptionProduct(industoryIdDefault, optionsProduct);
  }

  // モーダルクローズハンドラ
  const handleModalClose = () => {
    setOpen(false);
  };

  // 再読み込みボタンクリック
  const handleRedisplay = () => {
    setRedisplay(redisplay + 1);
  };

  // モーダルオープンハンドラ
  const handleOpen = () => {
    setOpen(true);
    setRedisplay(redisplay + 1);
  }

  // 業種カテゴリ変更ハンドラ
  const onChangeOption = (event: any) => {
    createNewOption(event.value, optionIndustries);
    createNewOptionProduct(0, optionProducts);
    setCategoryIdLocal(event.value);
    setIndustoryIdLocal(0);
    setProductIdLocal(0);
    setCommitDisabled(true);
  }

  // 業種変更ハンドラ
  const handleChangeIndustory = (event: any) => {
    createNewOptionProduct(event.value, optionProducts);
    setIndustoryIdLocal(event.value);
    setProductIdLocal(0);
    setCommitDisabled(true);
  };

  // 商品変更ハンドラ
  const handleChangeProduct = (event: any) => {
    setProductIdLocal(event.value);
    setCommitDisabled(false);
  };

  // 決定ボタンクリックハンドラ
  const handleClose = () => {
    setIndustoryId(industoryIdLocal);
    setIndustoryName(optionIndustries.find((v) => v.value === industoryIdLocal)?.label);
    setIndustoryNameOld(optionIndustries.find((v) => v.value === industoryIdLocal)?.label);
    setProductId(productIdLocal);
    setProductName(optionProducts.find((v) => v.value === productIdLocal)?.label);
    setIndustoryNameLog(optionIndustries.find((v) => v.value === industoryIdLocal)?.label);
    setOpen(false);
  };

  // 業種編集ボタンクリックハンドラ
  const handleIndustory = () => {
    const url = masterindustorys_path
    window.open(url);
  };

  // 商品編集ボタンクリックハンドラ
  const handleProduct = () => {
    const url = masterproducts_path
    window.open(url);
  };

  // 業種カテゴリ選択リスト作成
  function createCategoryOption(industorycategory:Industorycategory[]) {
    var options_category: Option[];
    options_category = industorycategory? industorycategory.map((option) => {
      return {value:option.industorycategoryId, label:option.industorycategoryName}
    }) : [];
    setOptionCategories(options_category);
  }

  // 業種選択リスト作成
  function createIndustoryOption(industory:Industory[]) {
    var optionsIndustory: OptionLocal[];
    optionsIndustory = industory ? industory.map((option) => {
      return {value:option.industoryId, label:option.industoryName, category:option.industorycategoryId}
    }) : [];
    setOptionIndustries(optionsIndustory);
    return optionsIndustory;
  }

  // 商品選択カテゴリ作成
  function createProductOption(product:Product[]) {
    var optionsProduct: OptionLocal[];
    optionsProduct = product ? product.map((option) => {
      return {value:option.productId, label:option.productName, category:option.industoryId}
    }) : [];
    setOptionProducts(optionsProduct);
    return optionsProduct;
  }

  // 業種カテゴリ変更 -> 業種オプション作成
  function createNewOption(value:number, optionIndustries:OptionLocal[]) {
    var newOptionIndustries: OptionLocal[];
    newOptionIndustries = []
    optionIndustries.map((option) => {
      if (value === option.category) {
        newOptionIndustries.push(
          {
            value: option.value,
            label: option.label,
            category: option.category,
          }
        );
      }
      return null;
    });
    setTempIndustries(newOptionIndustries);
  }

  // 業種変更 -> 商品オプション作成
  function createNewOptionProduct(value:number, optionProducts:OptionLocal[]) {
    var newOptionProducts: OptionLocal[];
    newOptionProducts = []
    optionProducts.map((option) => {
      if (value === option.category) {
        newOptionProducts.push(
          {
            value: option.value,
            label: option.label,
            category: option.category,
          }
        );
      }
      return null;
    });
    setTempProducts(newOptionProducts);
  }

  // 画面表示
  return (
    <React.Fragment>
      <Button 
        variant="contained"
        color="primary"
        onClick={handleOpen}>
        {"カテゴリ検索"}
      </Button>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleModalClose}
      >
      <div style={modalStyle} className={classes.paper}>
          <React.Fragment>
            <Card className={classes.root} square variant="outlined" style={{height: 550}}>
                <Box m={1}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      業種カテゴリ
                    </Typography>
                    <Select
                      id="industorycategory"
                      name="industorycategory"
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={industorycategory ? "Loaded" : "Loading"}
                      value={categoryIdLocal !== 0 ? optionCategories.find((v) => v.value === categoryIdLocal) : {value:0, label:""}}
                      options={optionCategories}
                      onChange={(e) => onChangeOption(e)}
                    />
                  </Grid>
                </Box>
                <Box m={1}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      業種
                    </Typography>
                    <Select
                      id="industory"
                      name="industory"
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={optionIndustries ? "Loaded" : "Loading"}
                      value={industoryIdLocal !== 0 ? tempIndustries.find((v) => v.value === industoryIdLocal) : {value:0, label:""}}
                      options={tempIndustries}
                      onChange={(e) => handleChangeIndustory(e)}
                    />
                  </Grid>
                </Box>
                <Box m={1}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      商品名称
                    </Typography>
                    <Select
                      id="product"
                      name="product"
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={tempProducts ? "Loaded" : "Loading"}
                      value={productIdLocal !== 0 ? tempProducts.find((v) => v.value === productIdLocal) : {value:0, label:""}}
                      options={tempProducts}
                      onChange={(e) => handleChangeProduct(e)}
                    />
                  </Grid>
                </Box>
                <Button onClick={handleClose} variant="outlined" color="primary" className={buttonClass} style={bStyle} disabled={commitDisabled}>
                決定
                </Button>
                <Button onClick={handleRedisplay} variant="outlined" color="primary" className={buttonClass} style={bStyle}>
                再読み込み
                </Button>
                <Button onClick={handleIndustory} variant="outlined" color="primary" className={buttonClass} style={bStyle}>
                業種編集
                </Button>
                <Button onClick={handleProduct} variant="outlined" color="primary" className={buttonClass} style={bStyle}>
                商品編集
                </Button>
              <CardActions className={classes.cardaction}>
              </CardActions>
            </Card>
          </React.Fragment>
        </div>
      </Modal>
    </React.Fragment>
  );
}
